// https://vuex.vuejs.org/en/getters.html

export default {
  users(state) {
    return state.users;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
